import { revokedBadgeReasonsClassifierEntityName } from '../../../../backend/config/classifiers/revoked-badge-reasons-classifier/types';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { buildStorageValueProvider } from '@juvare/platform-sdk-react/ui/features/classifiers';
export function useRevokedBadgeReasonsValueProvider() {
    const { t } = useBadgingTranslation();
    return buildStorageValueProvider({
        entityName: revokedBadgeReasonsClassifierEntityName,
        label: t('classifiers.revokedBadgeReasonsTitle'),
    });
}
